import styled from 'styled-components'

import { mixins } from '../utils/mixins'

export const Container = styled.div`
  flex-grow: 1;
  margin: 0 auto;
  ${mixins.siteGutter()}
`
